// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles-module--wrapper--1H0nf","container":"styles-module--container--10q0F","body":"styles-module--body--2s3Pe","cardsContainer":"styles-module--cardsContainer--3mfV5"};